import React, { Component } from 'react';
import { Field, FieldArray } from 'redux-form';
import { AsyncCreatable } from 'react-select';
import * as _ from 'lodash';

import {renderErrorAlert, renderField, renderSelect} from "../Common/RenderFieldTypes";

import "./DraftEdit.css";

class DraftEdit extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            timer: null
        };
        this.renderRounds = this.renderRounds.bind(this);
        this.renderPicks = this.renderPicks.bind(this);
        this.renderPickDetails = this.renderPickDetails.bind(this);
        this.getPlayerOptions = this.getPlayerOptions.bind(this);

        this.timer = null;
    }

    componentDidMount() {
        this.props.fetchAllTeams();
        if (this.props.match && this.props.match.params && this.props.match.params.id) {
            this.props.fetchDraft(this.props.match.params.id)
        }
    }
    
    componentWillReceiveProps(newProps) {
        if (!this.state.teams && !_.isEmpty(newProps.teams)) {
            this.setState({
                teams: _.map(newProps.teams, (team, index) => {
                    return team;
                })
            });
        }
    }

    onSubmit(val) {
        this.setState({submitError: ''});
        return this.props.createDraft(val).then((response) => {
            if (response.payload) {
                if (response.payload.name === 'ValidationError') {
                    this.setState({
                        submitError: 'There was an error submitting. Please try again.'
                    });
                } else {
                    this.props.history.push(`/`);
                }
            } else {
                this.setState({
                    submitError: 'There was an error submitting. Please try again.'
                });
            }
        });
    }

    getPlayerOptions(input, callback) {
        clearTimeout(this.timer);
        if (!input) {
            callback(null, {options: []})
        } else {
            this.timer = setTimeout(() => {
                this.props.fetchPlayersByName(input)
                .then((response) => {
                    callback(null, {options: response && Array.isArray(response) ? _.sortBy(response, ['fullName']) : []});
                });
            }, 750)
        }
    }

    renderAsyncCreatable(field) {
        const {label, input, labelKey, valueKey, placeholder, openOnFocus, divClassName, loadOptions,
            meta: {error, touched, warning}, onChange} = field;
            if (typeof input.value !== 'object') {
                input.value = {id: input.value, fullName: input.value};
            }
        return (
            <div className={divClassName ? divClassName : "form-group"}>
                <label className={error && touched ? "text-danger" : ""}>{label}</label>
                <AsyncCreatable
                    name={input.name}
                    className={(error && touched ? " dropdown-invalid" : "")}
                    onChange={onChange && typeof onChange === 'function' ? onChange : input.onChange}
                    openOnFocus={openOnFocus}
                    placeholder={placeholder}
                    value={input.value}
                    labelKey={labelKey}
                    valueKey={valueKey}
                    loadOptions={loadOptions}
                />
                <div>
                    {touched &&
                    ((error && <span className="text-danger">{error}</span>) ||
                        (warning && <span className="text-warning">{warning}</span>))}
                </div>
            </div>
        );
    }

    renderRounds(field) {
        if (field.fields.length <= 0) {
            field.fields.push({});
        }
        return (
            <div>
                <ul>
                    {field.fields.map((round, index) =>
                        <li key={index} className="small-margin-vertical">
                            <div>
                                <div>
                                    <button
                                        className="btn btn-danger btn-number btn-sm smallest-margin-right float-left mr-2"
                                        type="button"
                                        datatype="minus"
                                        title="Remove"
                                        onClick={() => field.fields.remove(index)}>
                                        <i className="fa fa-minus"/>
                                    </button>
                                    {(index+1 < field.fields.length) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move down"
                                                    onClick={() => field.fields.swap(index, index+1)}>
                                                    <i className="fa fa-arrow-down"/>
                                                </button> : <div/>
                                    }
                                    {(index !== 0) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move up"
                                                    onClick={() => field.fields.swap(index, index-1)}>
                                                    <i className="fa fa-arrow-up"/>
                                                </button> : <div/>
                                    }
                                    <h4>Round #{index + 1}</h4>
                                </div>
                                <div className="pl-5 mt-3">
                                    <FieldArray name={`${round}.picks`} props={
                                            {
                                                round: round
                                            }
                                        } component={this.renderPicks}/>
                                </div>
                            </div>
                        </li>
                    )}
                    <li className="addRound">
                        <button type="button" className="btn btn-primary" onClick={() => field.fields.push({})}>Add
                            Round
                        </button>
                    </li>
                </ul>
                <hr/>
            </div>
        )
    }

    renderPicks(field) {
        if (field.fields.length <= 0) {
            field.fields.push({});
        }
        return (
            <div>
                <ul>
                    {field.fields.map((pick, index) =>
                        <li key={index} className="small-margin-vertical">
                            <div>
                                <div>
                                    <button
                                        className="btn btn-danger btn-number btn-sm smallest-margin-right float-left mr-2"
                                        type="button"
                                        datatype="minus"
                                        title="Remove"
                                        onClick={() => field.fields.remove(index)}>
                                        <i className="fa fa-minus"/>
                                    </button>
                                    {(index+1 < field.fields.length) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move down"
                                                    onClick={() => field.fields.swap(index, index+1)}>
                                                    <i className="fa fa-arrow-down"/>
                                                </button> : <div/>
                                    }
                                    {(index !== 0) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move up"
                                                    onClick={() => field.fields.swap(index, index-1)}>
                                                    <i className="fa fa-arrow-up"/>
                                                </button> : <div/>
                                    }
                                    <h4>Pick #{index + 1}</h4>
                                </div>
                                <div className="col-12">
                                    <div className="small-margin-top">
                                    <Field
                                        name={`${pick}.draftPick`}
                                        label={'Draft Pick'}
                                        placeholder={'Player Name'}
                                        openOnFocus={true}
                                        loadOptions={this.getPlayerOptions}
                                        labelKey={'fullName'}
                                        valueKey={'id'}
                                        component={this.renderAsyncCreatable}/>

                                    </div>
                                </div>
                                <div className="pl-5">
                                    <FieldArray name={`${pick}.details`} props={
                                        {
                                            pick: pick
                                        }
                                    } component={this.renderPickDetails}/>
                                </div>
                            </div>
                        </li>
                    )}
                    <li className="addPick">
                        <button type="button" className="btn btn-primary" onClick={() => field.fields.push({})}>Add
                            Pick
                        </button>
                    </li>
                </ul>
                <hr/>
            </div>
        )
    }

    renderPickDetails(field) {
        if (field.fields.length <= 0) {
            field.fields.push({});
        }
        return (
            <div>
                <ul>
                    <li className="addPickDetails mb-4">
                        <button type="button" className="btn btn-primary" onClick={() => field.fields.unshift({})}>Add
                            Pick Detail
                        </button>
                    </li>
                    {field.fields.map((pick, index) =>
                        <li key={index} className="small-margin-vertical">
                            <div>
                                <div>
                                    <button
                                        className="btn btn-danger btn-number btn-sm smallest-margin-right float-left mr-2"
                                        type="button"
                                        datatype="minus"
                                        title="Remove"
                                        onClick={() => field.fields.remove(index)}>
                                        <i className="fa fa-minus"/>
                                    </button>
                                    {(index+1 < field.fields.length) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move down"
                                                    onClick={() => field.fields.swap(index, index+1)}>
                                                    <i className="fa fa-arrow-down"/>
                                                </button> : <div/>
                                    }
                                    {(index !== 0) ?
                                                <button
                                                    className="btn btn-info btn-number btn-sm smallest-margin-right float-left mr-2"
                                                    type="button"
                                                    title="Move up"
                                                    onClick={() => field.fields.swap(index, index-1)}>
                                                    <i className="fa fa-arrow-up"/>
                                                </button> : <div/>
                                    }
                                    <h4>Pick Seq Number #{index + 1}</h4>
                                </div>
                                <div className="col-12">
                                    <div className="small-margin-top">
                                        <Field
                                            name={`${pick}.team`}
                                            label={'Owning Team'}
                                            placeholder={''}
                                            openOnFocus={true}
                                            simpleValue={true}
                                            options={(!_.isEmpty(this.state.teams) && Array.isArray(this.state.teams)) ? this.state.teams : []}
                                            labelKey={'owner'}
                                            valueKey={'id'}
                                            component={renderSelect} />
                                    </div>
                                    <Field
                                        name={`${pick}.notes`}
                                        type="text"
                                        label="Draft Order Notes"
                                        component={renderField} />
                                </div>
                            </div>
                        </li>
                    )}
                </ul>
                <hr/>
            </div>
        )
    }

    render() {
        const { handleSubmit, pristine, submitting, submitFailed, error  } = this.props;
        return (
            <div>
                <h1>Draft Creation</h1>
                <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                    <Field name="year" className="form-control" component={renderField} type={"number"} label="Year" />
                    <Field
                        name={'championTeamId'}
                        label={'Season Champion'}
                        placeholder={''}
                        openOnFocus={true}
                        simpleValue={true}
                        options={(!_.isEmpty(this.state.teams) && Array.isArray(this.state.teams)) ? this.state.teams : []}
                        labelKey={'owner'}
                        valueKey={'id'}
                        component={renderSelect} />
                    <Field name="recap" className="form-control" component={renderField} label="Recap" />
                    <div className="no-list-style">
                        <FieldArray name="rounds" component={this.renderRounds}/>
                    </div>
                    <div id="submitArea" className="pb-5">
                        <button type="submit" className="btn btn-success float-left" disabled={pristine || submitting}>
                            {submitting ? 'Saving...' : 'Save'}
                        </button>
                        {renderErrorAlert(submitFailed, error, this.state.submitError)}
                    </div>
                </form>
            </div>
        );
    }
}
export default DraftEdit;



// WEBPACK FOOTER //
// ./src/components/Draft/DraftEdit.js